import { useEffect, useState } from 'react'

// Keeps a text input responsive while only refetching once typing settles.
export function useDebounced<T>(value: T, delay = 300): T {
	const [debounced, setDebounced] = useState(value)
	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delay)
		return () => clearTimeout(timer)
	}, [value, delay])
	return debounced
}
